module.exports = __webpack_public_path__ + "static/media/analysis3.e5d0abf8.png";